import { assertNever } from "../util/assertNever";

export enum ComponentType {
  NONE = "none",
  CRM_SYNC = "crm_sync",
  NEWSLETTER_SYNC = "newsletter_sync",
  YANOVIS = "yanovis",
  LTS_TICKETING = "lts_ticketing",
  DISCOUNT_CODE = "discount_code",
  STATISTIC_REPORTING = "statistic_reporting",
  REST_API = "rest_api",
  VOUCHER = "voucher",
  LTS_SUEDTIROL_GUEST_PASS = "lts_suedtirol_guest_pass",
  SMARTPRICING = "smartpricing",
  INVOICE = "invoice",
}

export enum ComponentTypeParameter {
  CRM_SYNC = "crmSync",
  NEWSLETTER_SYNC = "newsletterSync",
  YANOVIS = "yanovis",
  LTS_TICKETING = "ltsTicketing",
  DISCOUNT_CODE = "discountCode",
  STATISTIC_REPORTING = "statisticReporting",
  REST_API = "rest_api",
  VOUCHER = "voucher",
  LTS_SUEDTIROL_GUEST_PASS = "ltsSuedtirolGuestPass",
  SMARTPRICING = "smartpricing",
  INVOICE = "invoice",
}

export function mapComponentTypeParameterToComponentType(componentTypeParameter: ComponentTypeParameter): ComponentType {
  switch (componentTypeParameter) {
    case ComponentTypeParameter.LTS_TICKETING:
      return ComponentType.LTS_TICKETING;
    case ComponentTypeParameter.DISCOUNT_CODE:
      return ComponentType.DISCOUNT_CODE;
    case ComponentTypeParameter.STATISTIC_REPORTING:
      return ComponentType.STATISTIC_REPORTING;
    case ComponentTypeParameter.REST_API:
      return ComponentType.REST_API;
    case ComponentTypeParameter.VOUCHER:
      return ComponentType.VOUCHER;
    case ComponentTypeParameter.CRM_SYNC:
      return ComponentType.CRM_SYNC;
    case ComponentTypeParameter.NEWSLETTER_SYNC:
      return ComponentType.NEWSLETTER_SYNC;
    case ComponentTypeParameter.YANOVIS:
      return ComponentType.YANOVIS;
    case ComponentTypeParameter.LTS_SUEDTIROL_GUEST_PASS:
      return ComponentType.LTS_SUEDTIROL_GUEST_PASS;
    case ComponentTypeParameter.SMARTPRICING:
      return ComponentType.SMARTPRICING;
    case ComponentTypeParameter.INVOICE:
      return ComponentType.INVOICE;
    default:
      assertNever(componentTypeParameter);
  }
}
